import { InstructionMapping } from "../i9-task-card";
import { CUSTOMER_SERVICE, NON_CUSTOMER_SERVICE } from "../../../config/appConfigConstants";
import { ChecklistBundle } from "../../../hooks/use-arb";

export const getCAInstructionMapping = ({ bundle }: { bundle: ChecklistBundle }) => {
  const caDefaultInstructionMapping: InstructionMapping = {
    [NON_CUSTOMER_SERVICE]: {
      // TODO: Get CaaS to provide list of possible status for CA work auth
    },
    [CUSTOMER_SERVICE]: {},
  };

  return caDefaultInstructionMapping;
};
